import { render, staticRenderFns } from "./courseNew.vue?vue&type=template&id=1bc6526a"
import script from "./courseNew.vue?vue&type=script&lang=js"
export * from "./courseNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports